import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  barLegend: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    width: '100%',
  },
  bar: {
    display: 'flex',
    height: 4,
    width: '100%',
    borderRadius: 9999,
    overflow: 'hidden',
    backgroundColor: C.seriesTotal,
  },
  barSegment: {
    height: 4,
  },
  legend: {
    display: 'flex',
    width: '100%',
  },
  legendItem: {
    flex: '1 0 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  legendLabelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
  },
  legendLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.mutedText,
    margin: 0,
    whiteSpace: 'nowrap',
  },
  legendValue: {
    fontWeight: 500,
    margin: 0,
    whiteSpace: 'nowrap',
    color: C.darkText,
  },
  legendCurrency: {
    fontSize: 12,
    letterSpacing: '0.5px',
    color: C.mutedText,
  },
  legendNumber: {
    fontSize: 14,
    lineHeight: '20px',
    color: C.darkText,
  },
}))
